import { ReactNode } from "react"
import { Link } from "react-router-dom"
import Button from "../Button"

export type ListHeaderProps = {
  Icon: JSX.Element
  title: string
  createButtonText?: string
  disableCreateButton?: boolean
  actions?: ReactNode
  operationKlassToCheckPermission?: string
}

const ListHeader = ({
  Icon,
  title,
  createButtonText,
  operationKlassToCheckPermission,
  disableCreateButton,
  actions: customActions,
}: ListHeaderProps) => {
  const renderDefaultButton =
    createButtonText && !customActions ? (
      <Link
        to={disableCreateButton ? "" : "create"}
        className={disableCreateButton ? "cursor-default" : ""}
      >
        <Button
          operationKlassToCheckPermission={operationKlassToCheckPermission}
          className="shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]"
          disabled={disableCreateButton}
        >
          {createButtonText}
        </Button>
      </Link>
    ) : null

  return (
    <div className="w-full flex justify-between items-center">
      <div className="flex gap-2 items-center">
        {Icon}
        <h2 className="text-2xl font-bold">{title}</h2>
      </div>
      {customActions ?? renderDefaultButton}
    </div>
  )
}

export default ListHeader
